import { fmtDate } from './format'

/** Notes for a desk screen whose answer ignores the group switch (`group_applied === false`). */
export const NOTE_GOOGLE = "Everyone: Google can't tell members apart."
export const NOTE_ISSUES = 'Issues counts members only.'
export const NOTE_GENERIC = "Everyone: this view isn't split by group yet."

/** The note to show, or null when the response was split by group. */
export function groupNoteText(applied: boolean | undefined, text: string = NOTE_GENERIC): string | null {
  return applied === false ? text : null
}

/** The note shown when a non-Everyone period includes days whose groups were
 *  rebuilt from membership dates. Null when there is nothing to say. */
export function statusApproxNote(group: string | undefined, meta: { status_approx?: boolean; status_first_live?: string | null } | null | undefined): string | null {
  if (!group || group === 'all' || !meta?.status_approx) return null
  if (meta.status_first_live) {
    return `Groups before ${fmtDate(meta.status_first_live, { month: 'short', day: 'numeric', timeZone: 'UTC' })} are reconstructed from membership dates and may be approximate.`
  }
  return 'Groups are reconstructed from membership dates and may be approximate.'
}
